export function buildBasecampBffLoginUrl(
  basecampUrl: string,
  returnPath: string,
): string {
  const base = basecampUrl.replace(/\/$/, '');
  const path = returnPath.startsWith('/') ? returnPath : `/${returnPath}`;
  return `${base}/bff/login?returnUrl=${encodeURIComponent(path)}`;
}
